import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';

export const BlogForm = ({ post, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    title: post?.title || '',
    excerpt: post?.excerpt || '',
    content: post?.content || '',
    image: post?.image || '',
    pdfUrl: post?.pdfUrl || '',
    author: post?.author || 'AGIPLUS CI',
    published: post?.published || false
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 overflow-y-auto">
      <div className="my-8">
        <Card className="w-full max-w-3xl bg-white">
          <CardContent className="p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-gray-900">
                {post ? 'Éditer l\'article' : 'Nouvel article'}
              </h2>
              <button
                onClick={onCancel}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Titre *
                </label>
                <Input
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  placeholder="Titre de l'article"
                  className="bg-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Extrait *
                </label>
                <Textarea
                  name="excerpt"
                  value={formData.excerpt}
                  onChange={handleChange}
                  required
                  placeholder="Bref résumé de l'article (max 200 caractères)"
                  rows={2}
                  maxLength={200}
                  className="bg-white resize-none"
                />
                <p className="text-xs text-gray-500 mt-1">{formData.excerpt.length}/200 caractères</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Contenu * (HTML supporté)
                </label>
                <Textarea
                  name="content"
                  value={formData.content}
                  onChange={handleChange}
                  required
                  placeholder="<p>Votre contenu ici...</p>"
                  rows={8}
                  className="bg-white resize-none font-mono text-sm"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Utilisez les balises HTML : &lt;p&gt;, &lt;h2&gt;, &lt;ul&gt;, &lt;li&gt;, &lt;strong&gt;, etc.
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Auteur
                </label>
                <Input
                  name="author"
                  value={formData.author}
                  onChange={handleChange}
                  placeholder="AGIPLUS CI"
                  className="bg-white"
                  data-testid="blog-author-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Image (URL)
                </label>
                <Input
                  name="image"
                  type="url"
                  value={formData.image}
                  onChange={handleChange}
                  placeholder="https://example.com/image.jpg"
                  className="bg-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  PDF Newsletter (URL, optionnel)
                </label>
                <Input
                  name="pdfUrl"
                  type="url"
                  value={formData.pdfUrl}
                  onChange={handleChange}
                  placeholder="/uploads/pdfs/newsletter.pdf"
                  className="bg-white"
                />
              </div>

              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
                <Switch
                  id="published"
                  checked={formData.published}
                  onCheckedChange={(checked) => setFormData({ ...formData, published: checked })}
                />
                <label htmlFor="published" className="text-sm font-medium text-gray-900">
                  Publier immédiatement
                </label>
              </div>

              <div className="flex gap-3 pt-4">
                <Button
                  type="button"
                  variant="outline"
                  onClick={onCancel}
                  className="flex-1"
                >
                  Annuler
                </Button>
                <Button
                  type="submit"
                  className="flex-1 bg-green-600 hover:bg-green-700 text-white"
                >
                  {post ? 'Mettre à jour' : 'Créer l\'article'}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};